<template>
 <Home/>
</template>

<script>

import Home from "@/views/Home.vue";
import BigWin from "@/components/BigWin.vue";

export default {
  name: 'App',
  components: {BigWin, Home}
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#app {
  min-height: 100%;
}

body {
  min-width: 320px;
  overflow-x: hidden;
  font-family: Arial, Helvetica, sans-serif;
}

button,
input,
textarea,
select {
  font: inherit;
}
</style>
